/**
 * Error code to Turkish message — Document 6 §8.6, Architecture §16.
 *
 * The API returns codes; this file owns every word the user reads. Server
 * message text is never rendered directly, because it is written for a
 * developer reading a log, not for an instructor holding a tablet.
 */

export const ERROR_MESSAGES = {
  INVALID_CREDENTIALS: 'Kullanıcı adı veya şifre hatalı.',
  ACCOUNT_LOCKED: 'Çok fazla hatalı deneme. Lütfen bir süre sonra tekrar deneyin.',
  STUDIO_INACTIVE: 'Stüdyo hesabı aktif değil. Lütfen destek ile iletişime geçin.',
  SESSION_EXPIRED: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
  UNAUTHENTICATED: 'Oturumunuz sona erdi. Lütfen tekrar giriş yapın.',
  INVALID_PASSWORD: 'Şifre hatalı.',
  ADMIN_REAUTH_REQUIRED: 'Bu işlem için stüdyo şifrenizi tekrar girmeniz gerekiyor.',
  ADMIN_REAUTH_EXPIRED: 'Yetki süreniz doldu. Lütfen şifrenizi tekrar girin.',
  INSTRUCTOR_NOT_SELECTED: 'Lütfen önce sistemi kullanan eğitmeni seçin.',
  TOO_MANY_ATTEMPTS: 'Çok fazla deneme yapıldı. Lütfen biraz bekleyin.',

  NOT_FOUND: 'Kayıt bulunamadı.',
  USERNAME_TAKEN: 'Bu kullanıcı adı zaten kullanılıyor.',
  VALIDATION_ERROR: 'Girilen bilgilerde hata var. Lütfen kontrol edin.',
  RATE_LIMITED: 'Çok sık istek gönderildi. Lütfen biraz bekleyin.',
  FORBIDDEN_ORIGIN: 'İstek reddedildi. Lütfen sayfayı yenileyip tekrar deneyin.',
  INTERNAL_ERROR: 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
  NETWORK_ERROR: 'Bağlantı kurulamadı. İnternet bağlantınızı kontrol edin.',

  EMPTY_MEASUREMENT: 'En az bir ölçüm değeri girmelisiniz.',
  INVALID_IMAGE_TYPE: 'Desteklenmeyen dosya türü. JPEG, PNG veya WebP yükleyin.',
  IMAGE_TOO_LARGE: 'Dosya çok büyük. Lütfen daha küçük bir görsel seçin.',
  UPLOAD_FAILED: 'Fotoğraf yüklenemedi. Tekrar deneyebilirsiniz.',
  EMPTY_REPORT:
    'Rapor oluşturmak için en az bir ölçüm, fotoğraf, hedef veya değerlendirme seçmelisiniz.',
  GENERATION_IN_PROGRESS: 'Rapor zaten oluşturuluyor. Lütfen bekleyin.',
  IDEMPOTENCY_KEY_REUSED: 'Bu istek daha önce farklı bir içerikle gönderilmiş.',
  PROFILE_REQUIRED:
    'Devam etmek için bir eğitmen profili seçin ya da yönetici olarak girin.',
  PDF_GENERATION_FAILED:
    'Rapor oluşturulamadı. Seçimleriniz korundu, tekrar deneyebilirsiniz.',
} as const;

export type ErrorCode = keyof typeof ERROR_MESSAGES;

export function messageFor(code: string): string {
  return ERROR_MESSAGES[code as ErrorCode] ?? ERROR_MESSAGES.INTERNAL_ERROR;
}
